import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const Tiktok24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgLight24 : s.svgDark24,
      `svg-icon--${icon}`
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    data-icon={getDataIconAttribute(chroma, icon, '24')}
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
  >
    <path
      d="M23,2.22044605e-14 L23,14.0206299 L20,14.02 L20,17.5335693 L9.5,17.5335693 L3.5,22.0335693 L3.50417122,17.5335693 L0,17.5335693 L0,3.03356934 L3,3.033 L3,2.22044605e-14 L23,2.22044605e-14 Z M18.5,4.53356934 L1.5,4.53356934 L1.5,16.0335693 L5.00556227,16.0335693 L5.00278339,19.0314818 L9,16.0335693 L18.5,16.0335693 L18.5,4.53356934 Z M21.5,1.5 L4.5,1.5 L4.5,3.033 L20,3.03356934 L20,12.52 L21.5,12.5206299 L21.5,1.5 Z"
      id="Chat"
    ></path>
  </svg>
);

export default Tiktok24;
